import { FC } from 'react'
import Skeleton from '@components/skeleton'
import { SkeletonTable } from '@components/skeleton-table'
import {
    FilterButton,
    Search,
    SearchFilterSection,
    SkeletonContent,
    Title,
    TitleSection,
} from '@components/skeleton-table/skeletonTable.styles'
import { CloudAppSection, SectionSubtitle } from './UsersSkeleton.styles'
import { UsersSkeletonProps } from './UsersSkeleton.types'

const DEFAULT_CLOUD_APP_COLUMN_COUNT = 5
const DEFAULT_CLOUD_APP_ROW_COUNT = 2
const DEFAULT_USERS_COLUMN_COUNT = 4
const DEFAULT_USERS_ROW_COUNT = 8

const UsersSkeleton: FC<UsersSkeletonProps> = ({
    cloudAppColumnCount = DEFAULT_CLOUD_APP_COLUMN_COUNT,
    cloudAppRowCount = DEFAULT_CLOUD_APP_ROW_COUNT,
    usersColumnCount = DEFAULT_USERS_COLUMN_COUNT,
    usersRowCount = DEFAULT_USERS_ROW_COUNT,
}) => {
    return (
        <Skeleton>
            <SkeletonContent>
                <TitleSection>
                    <Title />
                </TitleSection>
                <CloudAppSection data-testid="users-skeleton-cloud-app-section">
                    <SectionSubtitle />
                    <SkeletonTable
                        columnCount={cloudAppColumnCount}
                        rowCount={cloudAppRowCount}
                        testIdPrefix="users-skeleton-cloud-app"
                    />
                </CloudAppSection>
                <SearchFilterSection>
                    <Search />
                    <FilterButton />
                </SearchFilterSection>
                <SkeletonTable
                    columnCount={usersColumnCount}
                    rowCount={usersRowCount}
                    testIdPrefix="users-skeleton-users"
                />
            </SkeletonContent>
        </Skeleton>
    )
}

export default UsersSkeleton
